import React, { useState, useCallback, useEffect } from 'react';
import { styled } from '@mui/joy/styles';
import Sheet from '@mui/joy/Sheet';
import Grid from '@mui/joy/Grid';

import Box from '@mui/joy/Box';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import AspectRatio from '@mui/joy/AspectRatio';

////////////////////// Images
import VisitesIcon from '../../assets/iconStatistics/users.svg'
import EvaluationsIcon from '../../assets/iconStatistics/evaluations.svg'
import AdvertisersIcon from '../../assets/iconStatistics/advertisers.svg'
import ProfitsIcon from '../../assets/iconStatistics/profits.svg'

///////////////////// API
import { getShortReports } from '../../Api/common'

export default function CardVariants() {
  const [shortReport, setShortReport] = useState({})

  const listShortReports = useCallback( async () => {
    const res = await getShortReports();
    if(!res) {
      return
    }
    setShortReport(res)
  },[])

  useEffect(() => {
    listShortReports();
  },[listShortReports])

  return (
    // <Grid
    //   container
    //   spacing={{ xs: 2, md: 3 }}
    //   columns={{ xs: 4, sm: 8, md: 12 }}
    //   sx={{ flexGrow: 1 }}
    // >
    //   <Card variant="soft" sx={{ backgroundColor: '#F7F9FB', borderRadius: '10px' }}>
    //     <CardContent>
    //       <AspectRatio objectFit="contain" variant='plain' sx={{width:'65%'}}>
    //         <img
    //           src={VisitesIcon}
    //           srcSet={VisitesIcon}
    //           alt="A beautiful landscape."
    //         />
    //       </AspectRatio>
    //       <Typography level="title-md">عدد الزوار</Typography>
    //       <Typography>7500 زائر</Typography>
    //     </CardContent>
    //   </Card>
    // </Grid>

    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
      <Grid xs={6} md={3}>
        <Card variant="soft" sx={{ backgroundColor: '#F7F9FB', borderRadius: '10px', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
          <CardContent>
            <AspectRatio objectFit="contain" variant='plain' sx={{ width: '40%' }}>
              <img
                src={VisitesIcon}
                srcSet={VisitesIcon}
                alt="A beautiful landscape."
              />
            </AspectRatio>
            <Typography level="title-md">التقميات</Typography>
            <Typography>{shortReport.rates + ' تقيم'}</Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid xs={6} md={3}>
        <Card variant="soft" sx={{ backgroundColor: '#F7F9FB', borderRadius: '10px', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
          <CardContent>
            <AspectRatio objectFit="contain" variant='plain' sx={{ width: '40%' }}>
              <img
                src={EvaluationsIcon}
                srcSet={EvaluationsIcon}
                alt="A beautiful landscape."
              />
            </AspectRatio>
            <Typography level="title-md">السيارات</Typography>
            <Typography>{shortReport.cars + ' سيارة'}</Typography>
          </CardContent>
        </Card>
      </Grid>
      

      <Grid xs={6} md={3}>
        <Card variant="soft" sx={{ backgroundColor: '#F7F9FB', borderRadius: '10px', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
          <CardContent>
            <AspectRatio objectFit="contain" variant='plain' sx={{ width: '40%' }}>
              <img
                src={AdvertisersIcon}
                srcSet={AdvertisersIcon}
                alt="A beautiful landscape."
              />
            </AspectRatio>
            <Typography level="title-md">المعلنين</Typography>
            <Typography>{shortReport.advertises + ' معلن'}</Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid xs={6} md={3}>
        <Card variant="soft" sx={{ backgroundColor: '#F7F9FB', borderRadius: '10px', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
          <CardContent>
            <AspectRatio objectFit="contain" variant='plain' sx={{ width: '40%' }}>
              <img
                src={ProfitsIcon}
                srcSet={ProfitsIcon}
                alt="A beautiful landscape."
              />
            </AspectRatio>
            <Typography level="title-md">الطلبات</Typography>
            <Typography>{shortReport.orders + ' طلب'}</Typography>
          </CardContent>
        </Card>
      </Grid>
      
      
    </Grid>
  );
}